export class AggregatorAsEntityModel {
    aggregator;
    id;
    constructor(aggregator, id) {
        this.aggregator = aggregator;
        this.id = id;
    }
    getEntities() {
        return Object.fromEntries(Object.entries(this.aggregator.getAggregatedEntities()).map(([key, value]) => [key, value.aggregatedEntity]));
    }
    subscribeToChanges(callback) {
        this.aggregator.subscribeToChanges((updated, removed) => {
            callback(Object.fromEntries(Object.entries(updated).map(([key, value]) => [key, value.aggregatedEntity])), removed);
        });
        return () => { };
    }
    getId() {
        return this.id;
    }
    getAlias() {
        throw new Error("Method not implemented.");
    }
    setAlias(alias) {
        throw new Error("Method not implemented.");
    }
    executeOperation(operation) {
        return this.aggregator.execOperation(operation);
    }
}
//# sourceMappingURL=as-entity-model.js.map